// © Microsoft Corporation. All rights reserved.

import { ConnectorNamespaces } from "@msnews/experiences-constants";
import { ExperiencesSharedStateConnector } from "@msnews/experiences-shared-state";
import { PageBase } from "@msnews/experiences-redux";
import { getAppEnvironment } from "@msnews/core";

/**
 * chrome
 * The chrome API is not defined in Typescript
 */
declare global {
    // tslint:disable-next-line: completed-docs
    interface Window { chrome: any; }
}

/** The aadToken QS key */
export const aadTokenQsKey = "stn";

/** The aadToken QS value */
export const aadTokenQsVal = "aad";

/**
 * Gets a value to indicate if we are in an enterprise scenario
 * eg. whether we should append the AAD Token as part of the call to oneservice endpoints
 * The default value is false, so we don't need to wait until the value is explicitly set
 */
export function useEnterpriseCompliance(): boolean {
    // Obtain the current value of useEnterpriseCompliance from the ExperiencesSharedState connector
    const sharedStateConnector: ExperiencesSharedStateConnector = PageBase.getInstance().rootReducer.connector(ConnectorNamespaces.SharedState) as ExperiencesSharedStateConnector;
    return sharedStateConnector ? sharedStateConnector.getCurrentState().useEnterpriseCompliance : false;
}

/**
 * Checks if we were able to get a valid aad token for this user
 */
export function isValidAadToken(): boolean {
    const appEnvironment = getAppEnvironment();

    return appEnvironment.AadData && appEnvironment.AadData.isSuccess && appEnvironment.AadData.isValid;
}
/**
 * Gets a value to indicate if we should use enterprise domain
 * eg. whether we should use the Falcon domain vs. consumer domain for oneservice requests
 * The default value is false, so we don't need to wait until the value is explicitly set
 */
export function useEnterpriseDomain(): boolean {
    // Obtain the current value of useEnterpriseDomain from the ExperiencesSharedState connector
    const sharedStateConnector: ExperiencesSharedStateConnector = PageBase.getInstance().rootReducer.connector(ConnectorNamespaces.SharedState) as ExperiencesSharedStateConnector;
    return sharedStateConnector ? sharedStateConnector.getCurrentState().useEnterpriseDomain : false;
}